import { render } from "./mudarPassword.vue?vue&type=template&id=01c93fb1&scoped=true"
import script from "./mudarPassword.vue?vue&type=script&lang=js"
export * from "./mudarPassword.vue?vue&type=script&lang=js"

import "./mudarPassword.vue?vue&type=style&index=0&id=01c93fb1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c93fb1"]])

export default __exports__